export default __webpack_public_path__ + "static/media/Blade's Boots of the Black Arts.c488f20e.jpg";